import React, { useEffect, useState } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchInfoCapitalGoalsData, deleteSuccessFactor } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";
import ConfirmDialog from "../../components/common/ConfirmDialog";

export default function InfoCapitalGoalDataListPage() {
  const { businessDomainId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [targetRow, setTargetRow] = useState(null);

  const loadData = async () => {
    setLoading(true);
    try { setRows(await fetchInfoCapitalGoalsData(businessDomainId)); }
    catch (e) { notify.apiError(e); }
    finally { setLoading(false); }
  };
  useEffect(() => { loadData(); }, [businessDomainId]);

  const handleDelete = async () => {
    try {
      await deleteSuccessFactor(targetRow.successFactorId);
      notify.success(t("message.delete.success"));
      setConfirmOpen(false); setTargetRow(null); loadData();
    } catch (e) { notify.apiError(e); }
  };

  const columns = [
    { field: "successFactorName", headerName: t("successFactor.name"), flex: 1, minWidth: 200 },
    { field: "successFactorDescription", headerName: t("common.description"), flex: 1, minWidth: 200 },
    { field: "actions", headerName: t("common.actions"), width: 150, sortable: false,
      renderCell: (p) => (
        <Box>
          <IconButton size="small" onClick={() => navigate(`/strategy/${businessDomainId}/info-capital-goals-data/${p.row.successFactorId}`)}><VisibilityIcon fontSize="small" /></IconButton>
          <IconButton size="small" onClick={() => navigate(`/strategy/${businessDomainId}/info-capital-goals-data/${p.row.successFactorId}/edit`)}><EditIcon fontSize="small" /></IconButton>
          <IconButton size="small" color="error" onClick={() => { setTargetRow(p.row); setConfirmOpen(true); }}><DeleteIcon fontSize="small" /></IconButton>
        </Box>
      ),
    },
  ];

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">{t("infoCapitalGoalData.list.title")}</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate(`/strategy/${businessDomainId}/info-capital-goals-data/create`)}>{t("common.add")}</Button>
      </Box>
      <DataGrid rows={rows} columns={columns} getRowId={(r) => r.successFactorId} loading={loading} autoHeight pageSizeOptions={[10, 25, 50]} initialState={{ pagination: { paginationModel: { pageSize: 10 } } }} disableRowSelectionOnClick />
      <ConfirmDialog open={confirmOpen} onConfirm={handleDelete} onCancel={() => { setConfirmOpen(false); setTargetRow(null); }} />
    </Box>
  );
}
